export const ROLE_DATA = Object.freeze({
    user: {
        name: 'User'
    },
    admin: {
        name: 'Admin'
    }
});
